import { BulkOperations } from './BulkOperations';
export class BaseBulkOperationsModel {
  public arrBulkOperations: BulkOperations[] = [];
  constructor() {
    // Do Nothing
  }
}
